// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OiqT","left":"styles_left__3b3KU"};